import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedPlan: "free", // Default to Free Trial
};

const subscriptionSlice = createSlice({
  name: "subscription",
  initialState,
  reducers: {
    setSelectedPlan: (state, action) => {
      state.selectedPlan = action.payload;
    },
  },
});

export const { setSelectedPlan } = subscriptionSlice.actions;
export default subscriptionSlice.reducer;
